module.exports = __webpack_public_path__ + "static/media/page3-4.6c285664.png";